import React, { Suspense, lazy } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const IncludedSection = lazy(() => import('./components/IncludedSection').then(m => ({
  default: m.IncludedSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <main className="pt-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <Suspense fallback={null} data-id="element-4">
          <ProblemSection data-id="element-5" />
          <SolutionSection data-id="element-6" />
          <IncludedSection data-id="element-7" />
          <BonusSection data-id="element-8" />
          <TestimonialsSection data-id="element-9" />
          <PricingSection data-id="element-10" />
          <GuaranteeSection data-id="element-11" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-12">
        <FooterSection data-id="element-13" />
        <SocialProofPopup data-id="element-14" />
      </Suspense>
    </div>;
}